import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const postEmploymentCertificate = employmentCertificateData => {
  return dispatch => {
    dispatch({ type: "POST_EMPLOYMENT_CERTIFICATE_LOADING" });
    api
      .employmentCertificatePost(employmentCertificateData)
      .then(resp => {
        if (employmentCertificateData.id !== -1) {
          dispatch(postEditSucceeded(resp.data));
        } else {
          dispatch(postNewSucceeded(resp.data));
        }
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "AddEmploymentCertificateErrorAlertTitle",
          "Virhe työtodistuksen tallennuksessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const postNewSucceeded = data => ({
  type: "POST_EMPLOYMENT_CERTIFICATE_SUCCEEDED",
  payload: { employmentCertificateData: data },
});

const postEditSucceeded = data => ({
  type: "POST_EMPLOYMENT_CERTIFICATE_EDIT_SUCCEEDED",
  payload: { employmentCertificateData: data },
});

const operationFail = () => ({
  type: "POST_EMPLOYMENT_CERTIFICATE_FAIL"
});